import App from '../index.js';
import { groupBy, isEmpty, forEach, uniq } from 'lodash';

App.BotsForm = (function () {
    let botTemplate = $('<div class="bot-item"></div>').html($('#bot_item_template').find('.bot-item:last-child').html());
    const questionTemplate = $('<div class="question-item"></div>').html($('#bot_item_template .question-list .question-item:last-child').html());
    let touched = false;

    function addNewCategory () {
        let template = botTemplate.clone();
        const elBotBody = $('.bot-body');
        template.find('.category-field, .answer-field, .question-field, .global-bot-bot-item-id-field').val('');
        template.find('.question-item:not(:last-child)').remove();

        const updatedCurrentCounter = parseInt(elBotBody.find('.bot-item:last-child').data('counter') || 0) + 1;
        template.attr('data-counter', updatedCurrentCounter).data('counter', updatedCurrentCounter);

        template.find('.enable-global-bot-override-field').attr('id', 'enable_global_bot_override_' + updatedCurrentCounter);
        template.find('.enable-global-bot-override-label').attr('for', 'enable_global_bot_override_' + updatedCurrentCounter);

        elBotBody.append(template);
        buildWysiwygEditor();
        initSearchableSelectAjax($('.bot-body .bot-item .searchable-select-ajax:not(.select2-hidden-accessible)'));
    }

    function prepareDataToSend ( e ) {
        e.preventDefault();
        touched = false;
        window.onbeforeunload = null;

        const elForm = $(this);

        elForm.find('.bot-body .bot-item').each(function ( botItemIndex, event ) {
            let elBotItem = $(this);

            elBotItem.find('.id-field').attr('name', `items[${ botItemIndex }][id]`);

            elBotItem.find('.enabled-field').attr('name', `items[${ botItemIndex }][enabled]`);
            elBotItem.find('.category-field').attr('name', `items[${ botItemIndex }][category]`);
            elBotItem.find('.answer-field').attr('name', `items[${ botItemIndex }][answer]`);
            elBotItem.find('.enable-global-bot-override-field').attr('name', `items[${ botItemIndex }][enable_global_bot_override]`);
            elBotItem.find('.global-bot-bot-item-id-field').attr('name', `items[${ botItemIndex }][global_bot_bot_item_id]`);
            elBotItem.find('.global-bot-override-primary-question-field').attr('name', `items[${ botItemIndex }][global_bot_bot_item_primary_question]`);

            elBotItem.find('.question-item').each(function ( questionItemIndex, event ) {
                let elQuestionItemID = $(this).find('.question-id-field'),
                    elQuestionItem = $(this).find('.question-field');
                if (!isEmpty(elQuestionItem.val())) {
                    elQuestionItemID.attr('name', `items[${ botItemIndex }][questions][${ questionItemIndex }][id]`);
                    elQuestionItem.attr('name', `items[${ botItemIndex }][questions][${ questionItemIndex }][text]`);
                }
            });

            if ($(this).is(':last-child')) {
                elBotItem.find('.id-field, .category-field, .answer-field, .question-item .question-id-field, .question-item .question-field, .global-bot-bot-item-id-field, .enable-global-bot-override-field').removeAttr('name');
            }
        });

        elForm[0].submit();
    }

    function preventPageLoad () {
        if (!touched) {
            window.onbeforeunload = function () {
                return touched ? "You haven't save your changes! are you sure you want to leave?" : false;
            }
            touched = true;
        }
    }

    function uploadCsvData () {
        const formFile = this;
        if (!window.File || !window.FileReader || !window.FileList || !window.Blob) {
            console.log('The File APIs are not fully supported in this browser.');
            return;
        }

        if (!formFile.files) {
            console.error("This browser doesn't seem to support the `files` property of file inputs.");
        } else if (formFile.files[0]) {
            const fileName = $(this).val();

            if (!isCSVFile(fileName)) {
                $(this).val('');
                alert('Please select correct file format');
                return;
            }
            $('#bot_data .bot-body .bot-item:last-child').remove();
            const elBotList = $('.bot-list');

            elBotList.addClass('loading');

            setTimeout(() => {
                let file = formFile.files[0];
                let fr = new FileReader();
                receivedText = () => {
                    const jsonResult = $.csv.toObjects(fr.result);
                    updateFormFromCSV(jsonResult);
                    elBotList.removeClass('loading');
                }

                fr.onload = receivedText;
                fr.readAsText(file);
            }, 500);

        }
    }


    function isCSVFile ( fileName ) {
        var regex = new RegExp("(.*?)\.(csv)$");
        return regex.test(fileName.toLowerCase());
    }

    function updateFormFromCSV ( json ) {

        if (!isEmpty(json)) {
            let keys = Object.keys(json[0]);

            if (!keys.includes('Category') || !keys.includes('Question') || !keys.includes('Answer')) {
                $('.alert-holder').html(`<div class="alert alert-danger d-flex align-items-center" role="alert">Upload failed. Category, Question, Answer are required columns.</div>`);
            } else {
                $('.alert-holder').empty();
            }

            forEach(json, ( item, index ) => {
                const currentBotTemplate = $('<div/>').html(botTemplate.clone());

                if (!isEmpty(item.Question)) {
                    let questions = uniq(item.Question.split(/\n/));
                    const questionListTemplate = [];

                    forEach(questions, function ( question, question_index ) {
                        if (!$('.question-field[value="' + CSS.escape(question) + '"]')[0]) {
                            const currentQuestionTemplate = $('<div/>').html(questionTemplate.clone());
                            currentQuestionTemplate.find('.question-field').attr('value', question);
                            questionListTemplate.push(currentQuestionTemplate.html())
                        }
                    });

                    currentBotTemplate.find('.question-list').html(questionListTemplate.join(' '));
                }

                if (!isEmpty(currentBotTemplate.find('.question-list .question-item:first-child .question-field').val())) {
                    currentBotTemplate.find('.category-field').attr('value', item.Category);
                    currentBotTemplate.find('.answer-field').html($('<div/>').html(item.Answer).text().linkify());
                    $('#bot_data .bot-body').append(currentBotTemplate.html());
                }
            });
        }

        addNewCategory();
        buildWysiwygEditor();
        $('#upload_data').val('');
    }

    function buildWysiwygEditor () {
        App.wysiwygEditor('.bot-body .bot-item .answer-field:not(.mce-active)', 200, function (el,  data ) {
            if (el.closest('.bot-item').is(':last-child')) {
                addNewCategory();
            }

            preventPageLoad();
        }, null,'numlist bullist');
    }

    function onChangeGlobalBotOverride () {
        const el = $(this);
        el.closest('.global-bot-override-group').find('.global-bot-override-select').toggleClass('d-none', !el.is(':checked'));
        el.closest('.global-bot-override-group').find('.global-bot-bot-item-id-field').val('');
    }

    function extractCategories(data) {
        const result = [];

        data.items.forEach((category) => {
            // Iterate over children in the category
            if (category.children && category.children.length > 0) {
                // Push top-level category
                result.push({
                    id: category.id,
                    text: category.text,
                    disabled: true,
                    type: 'category'
                });

                category.children.forEach((primaryQuestion) => {
                    result.push({
                        id: primaryQuestion.bot_item_id,
                        text: primaryQuestion.text,
                        type: 'primary_question',
                        bot_item_id: primaryQuestion.bot_item_id,
                        category: category.text,
                    });

                    // Check for nested children (if any)
                    if (primaryQuestion.children && primaryQuestion.children.length > 0) {
                        primaryQuestion.children.forEach((secondaryQuestion) => {
                            result.push({
                                id: secondaryQuestion.bot_item_id,
                                text: secondaryQuestion.text,
                                type: 'question',
                                bot_item_id: secondaryQuestion.bot_item_id,
                                category: category.text,
                                primary_question: primaryQuestion.text,
                            });
                        });
                    }
                });
            }


        });

        return result;
    }


    function initSearchableSelectAjax ( elSearchableSelectItems) {
        elSearchableSelectItems.each(function (  ) {
            const elSearchableSelectItem = $(this);
            const initialData =[{
                id: elSearchableSelectItem.val(),
                text: elSearchableSelectItem.data('question'),
                category: elSearchableSelectItem.data('category'),
            }];

            elSearchableSelectItem.select2({
                theme: "bootstrap-5",
                dropdownCssClass: 'searchable-select-dropdown',
                ajax: {
                    delay: 250,
                    method: 'POST',
                    url: elSearchableSelectItem.data('url'),
                    data: function (params) {
                        if (params.term) {
                            $('.searchable-select-dropdown .select2-results .loading-results').show()
                        } else {
                            $('.searchable-select-dropdown .select2-results .loading-results').hide()
                        }

                        let excludeBotItems = $('.bot-body').find('.global-bot-bot-item-id-field').map(function (  ) {
                            return $(this).data('bot-item-id');
                        }).toArray();

                        return {
                            _token: $('[name="csrf-token"]').attr('content'),
                            text: params.term,
                            exclude_bot_items: excludeBotItems
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: extractCategories(data)
                        }
                    }
                },
                templateSelection: templateSelectionAjax,
                templateResult: formatOptionAjax, // Customize option appearance
                data: initialData
            });
        });
    }


    function templateSelectionAjax ( repo) {
        const elOption = $(repo.element);
        elOption.closest('select').attr('data-bot-item-id', repo.bot_item_id).data('bot-item-id', repo.bot_item_id)
        .attr('data-type', repo.type).data('type', repo.type);

        if (!repo.type) {
            repo.type = elOption.closest('select').data('type')
        }

        if (!repo.category) {
            repo.category = elOption.closest('select').data('category')
        }

        if (!repo.primary_question) {
            repo.primary_question = elOption.closest('select').data('primary-question')
        }

        const icon = ['question', 'primary_question'].includes(repo.type) ? '<i class="fa-regular fa-circle-question"></i>' : ( repo.type === 'category' ? '<i class="fa-regular fa-folder-open"></i>' : '');

        if(repo.type === 'category') {
            return $(`<span>${icon} <strong>${ repo.text }</strong></span>`);
        } else if (repo.type === 'primary_question') {
            return $(`<span>${icon} <strong>${repo.category}</strong> - ${ repo.text }</span>`);
        } else if(repo.type === 'question') {
            return $(`<span>${icon} <strong>${repo.category}</strong> - ${repo.primary_question}</span>`);
        }

        return $(`<span>${icon} <strong>${ repo.text }</strong></span>`);
    }


    // Format the dropdown options
    function formatOptionAjax(option) {
        if (!option.id) {
            return option.text; // Return unmodified for the placeholder
        }

        const type = option?.type || $(option.element).data('type'); // Get the option type

        if ( type === 'category' ) {
            return $('<span><i class="fa-regular fa-folder-open"></i> <strong>' + option.text + '</strong></span>');
        } else if( type === 'primary_question' ) {
            return $('<div class="px-4"><i class="fa-regular fa-circle-question"></i> ' +
                '<span><strong>' + option.text + '</strong></span>' +
                '</div>');
        } else if( type === 'question' ) {
            return $('<div class="px-4 mx-4"><i class="fa-regular fa-circle-question"></i> ' +
                '<span>' + option.text  + '</span>' +
                '</div>');
        }

        return $('<span>' + option.text + '</span>');
    }

    return {
        init: function () {
            buildWysiwygEditor();
            initSearchableSelectAjax($('.bot-body .bot-item .searchable-select-ajax:not(.select2-hidden-accessible)'));

            $('body')
                .on('input', '.answer-field, .question-field, .category-field', function () {
                    const el = $(this);

                    if (el.closest('.bot-item').is(':last-child')) {
                        addNewCategory();
                    }
                    preventPageLoad();
                })
                .on('input', '[name="name"]', preventPageLoad)
                .on('change', '.question-field', function () {
                    $(this).attr('value', $(this).val());
                })
                .on('click', '#add_category', addNewCategory)
                .on('click', '.bot-item .delete-bot-item', function () {
                    $(this).closest('.bot-item').remove();
                    preventPageLoad();
                })
                .on('click', '.bot-item-question .add-question-item', function ( e ) {
                    e.preventDefault();
                    questionTemplate.find('.question-field').attr('placeholder', 'Question').val('');
                    questionTemplate.find('.question-id-field').attr('placeholder', 'Question').val('');
                    $(this).closest('.bot-item-question').find('.question-list').append(questionTemplate.clone());
                    preventPageLoad();
                })
                .on('click', '.bot-item-question .delete-question-item .btn-delete', function ( e ) {
                    e.preventDefault();
                    $(this).closest('.question-item').remove();
                    preventPageLoad();
                }).on('change', '#upload_data', uploadCsvData)
                .on('change', '.global-bot-override-group .enable-global-bot-override-field', onChangeGlobalBotOverride)
                .on('change',  '.global-bot-bot-item-id-field', function (  ) {
                    $(this).closest('.global-bot-override-group').find('.global-bot-override-primary-question-field').val($(this).find('option[value="' +$(this).val()+'"]').text())
                });

            $('#bot_form').on('submit', prepareDataToSend);
        }
    };

})();

// Provide the route name
App.registerRoute('organizations.bots.create', App.BotsForm.init);
App.registerRoute('organizations.bots.edit', App.BotsForm.init);

export default App.BotsForm;
